import { createWebHistory, createRouter } from 'vue-router'

import ExternalUser from '@/views/ExternalUser'
import Moc from '@/views/Moc'
import Archive from '@/views/Archive'

import beforeEnterConfidentialCommunityGuard from '@/navigationGuards/beforeEnterConfidentialCommunityGuard'
import beforeEnterDbAccess from '@/navigationGuards/beforeEnterDbAccess'

// Admin
import ProcessManager from '@/views/ProcessManager'
import Communities from '@/views/Communities'
import AddOrUpdateCommunity from '@/views/AddOrUpdateCommunity'
import CommunityDashboard from '@/views/CommunityDashboard'
import ITSupport from '@/views/ITSupport'
import UserReplacement from '@/views/UserReplacement'
import UserReplacementMoc from '@/views/UserReplacementMoc'
import UserReplacementMocDetails from '@/views/UserReplacementMocDetails'
import DisplayNameOverride from '@/views/DisplayNameOverride'
import CommunityClone from '@/views/CommunityClone'
import _403Forbidden from '@/views/httpCodes/403Forbidden'
import NavBar from '@/views/NavBar'
import ExternalMocForm from '@/views/ExternalMocForm'
import UnauthorizedColors from '@/views/developer/UnauthorizedColors'
import NotificationTester from '@/views/developer/NotificationTester'
import DbAccessControl from '@/views/developer/DbAccessControl'
import TranslationSettings from '@/views/admin/Translations'
import Home from '@/views/Home'
import News from '@/views/News'
import { globals } from './main.js'

const internalRoutes = [
  {
    path: '/',
    redirect: {
      name: 'Home'
    }
  },
  {
    path: '/Home',
    name: 'Home',
    component: CommunityDashboard,
    meta: {
      requireAuth: true
    }
  },
  {
    // new moc
    path: '/:shortName/Moc',
    component: Moc,
    props: true,
    beforeEnter: beforeEnterConfidentialCommunityGuard('shortName'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/:shortName/Moc/:id',
    component: Moc,
    props: true,
    beforeEnter: beforeEnterConfidentialCommunityGuard('shortName'),    
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/ProcessManager',
    name: 'ProcessManager',
    component: ProcessManager,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/CommunityConfiguration',
    name: 'Community Configuration',
    component: Communities,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/:shortName?/CommunityConfig',
    beforeEnter: beforeEnterConfidentialCommunityGuard('shortName'),
    name: 'AddOrUpdateCommunity',
    component: AddOrUpdateCommunity,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/:shortName?/CommunityDashboard',
    beforeEnter: beforeEnterConfidentialCommunityGuard('shortName'),
    name: 'CommunityDashboard',
    component: CommunityDashboard,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/ITSupport',
    name: 'ITSupport',
    component: ITSupport,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/ITSupport/DisplayNameOverride',
    name: 'DisplayNameOverride',
    component: DisplayNameOverride,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/UserReplacement',
    name: 'UserReplacement',
    component: UserReplacement,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/UserReplacementMoc',
    name: 'UserReplacementMoc',
    component: UserReplacementMoc,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/userreplacementmoc/:communityAbbreviation/:reference',
    beforeEnter: beforeEnterConfidentialCommunityGuard('communityAbbreviation'),
    name: 'UserReplacementMocDetails',
    component: UserReplacementMocDetails,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/News',
    name: 'News',
    component: News,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/clonecommunity',
    name: 'CommunityClone',
    component: CommunityClone,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/developer',
    name: 'UnauthorizedColors',
    component: UnauthorizedColors,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/itsupport/notificationtester',
    name: 'NotificationTester',
    component: NotificationTester,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/dbaccesscontrol',
    name: 'DbAccessControl',
    beforeEnter: beforeEnterDbAccess,
    component: DbAccessControl,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/translations',
    name: 'Translations',
    component: TranslationSettings,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/Archive/:id',
    component: Archive,
    beforeEnter: beforeEnterConfidentialCommunityGuard('id'.substring(5, 8)),
    props: true,
    meta: {
      requireAuth: true
    }
  }
]

const internalRoutesResult = internalRoutes.map((r) => {
  return {
    ...r,
    components: { default: r.component, navbar: NavBar },
    component: undefined,
    // ...(r.props ? { props: { default: true } } : {})
  }
})
// console.log(`internalRoutesResult ${JSON.stringify(internalRoutesResult)}`)

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...internalRoutesResult,
    {
      path: '/external',
      children: [
        {
          path: ':shortName/moc/:id',
          props: true,
          component: ExternalMocForm
        }
      ],
      component: ExternalUser
    },
    {
      path: '/api/'
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: _403Forbidden
    }
  ]
})

// Global route guard
router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requireAuth)) {
    // this route requires auth, check if logged in
    //TODO: change this to check the token and not the user
    if (!(await globals.$authService.getLoggedIn())) {
      localStorage.setItem('emoc.internal.loginRedirectUrl', to.fullPath)
      await globals.$authService.loginRedirect()
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
